/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Buildingnamemalletc3Inputs */

const en_buildingnamemalletc3 = /** @type {(inputs: Buildingnamemalletc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Building Name, Mall, etc.`)
};

const de_buildingnamemalletc3 = /** @type {(inputs: Buildingnamemalletc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebäudename, Einkaufszentrum usw.`)
};

/**
* | output |
* | --- |
* | "Building Name, Mall, etc." |
*
* @param {Buildingnamemalletc3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const buildingnamemalletc3 = /** @type {((inputs?: Buildingnamemalletc3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Buildingnamemalletc3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_buildingnamemalletc3(inputs)
	return de_buildingnamemalletc3(inputs)
});
export { buildingnamemalletc3 as "buildingNameMallEtc" }